import PhotoForm from './PhotoForm';

export default PhotoForm;
